import { Profile } from './profile.model';

export interface IUser {
  uid: string;
  names: string;
  lastNames: string;
  email: string;
  profile: Profile;
  lastLoginAt: string | null;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class UserModel {
  uid: string;
  names: string;
  lastNames: string;
  email: string;
  profile: Profile;
  lastLoginAt: Date | null;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IUser) {
    this.uid = data.uid;
    this.names = data.names;
    this.lastNames = data.lastNames;
    this.email = data.email;
    this.profile = data.profile;
    this.lastLoginAt = data.lastLoginAt ? new Date(data.lastLoginAt) : null;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }

  get fullName(): string {
    return `${this.names} ${this.lastNames}`.trim();
  }

  get isSudo(): boolean {
    return this.profile === 'sudo';
  }
}
